/* =============================================================
   KAC Homepage — Interactive JS
   FAQ accordion + Find Your Club map switcher
   ============================================================= */

// ── FAQ Accordion ──────────────────────────────────────────────
function kacToggleFaq(btn) {
  var body   = btn.nextElementSibling;
  var isOpen = body.classList.contains('kac-faq-body--open');

  // Close all open items
  document.querySelectorAll('.kac-faq-body--open').forEach(function(b) {
    b.classList.remove('kac-faq-body--open');
  });
  document.querySelectorAll('.kac-faq-btn--open').forEach(function(b) {
    b.classList.remove('kac-faq-btn--open');
    b.setAttribute('aria-expanded', 'false');
  });

  // Open clicked item (if it was closed)
  if (!isOpen) {
    body.classList.add('kac-faq-body--open');
    btn.classList.add('kac-faq-btn--open');
    btn.setAttribute('aria-expanded', 'true');
  }
}

// ── Find Your Club ─────────────────────────────────────────────
function kacSelectClub(el, mapSrc) {
  // Deactivate all items
  document.querySelectorAll('.kac-club__item').forEach(function(item) {
    item.classList.remove('kac-club__item--active');
    var expand = item.querySelector('.kac-club__expand');
    if (expand) expand.classList.remove('kac-club__expand--open');
  });

  // Activate clicked item
  el.classList.add('kac-club__item--active');
  var expand = el.querySelector('.kac-club__expand');
  if (expand) expand.classList.add('kac-club__expand--open');

  // Update map
  var map = document.getElementById('kac-club-map');
  if (map) map.src = mapSrc;
}